/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Whattoexpect2Inputs */

const id_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Apa yang Diharapkan?`)
};

const ms_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Apa yang Dijangka?`)
};

const da_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Hvad kan du forvente?`)
};

const de_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Was Sie erwartet?`)
};

const en_us2_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 What to Expect?`)
};

const es_es2_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 ¿Qué esperar?`)
};

const es_mx2_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 ¿Qué esperar?`)
};

const fil_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano ang Aasahan?`)
};

const fr_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 À quoi s'attendre ?`)
};

const it_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa aspettarsi?`)
};

const hu_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mire számíthatsz?`)
};

const nl_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat kun je verwachten?`)
};

const no_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva du kan forvente?`)
};

const pl_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Czego się spodziewać?`)
};

const pt_br2_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 O que esperar?`)
};

const pt_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 O que esperar?`)
};

const ro_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 La ce să te aștepți?`)
};

const fi_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Mitä odottaa?`)
};

const sv_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Vad kan du förvänta dig?`)
};

const vi_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Bạn mong đợi điều gì?`)
};

const tr_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Ne Beklemeli?`)
};

const cs_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Co očekávat?`)
};

const bg_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Какво да очакваме?`)
};

const ru_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Чего ожидать?`)
};

const uk_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 Чого очікувати?`)
};

const ar_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 ماذا تتوقع؟`)
};

const hi_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या उम्मीद करें?`)
};

const th_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 สิ่งที่คาดหวัง?`)
};

const ja_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 どんな内容？`)
};

const zh_cn2_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🧩 有什么期待？`)
};

const zh_hant1_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有什麼期待？`)
};

const ko_misc_posts_whattoexpect2 = /** @type {(inputs: Misc_Posts_Whattoexpect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예상되는 내용:`)
};

/**
* | output |
* | --- |
* | "🧩 What to Expect?" |
*
* @param {Misc_Posts_Whattoexpect2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_whattoexpect2 = /** @type {((inputs?: Misc_Posts_Whattoexpect2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Whattoexpect2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_whattoexpect2(inputs)
	if (locale === "ms") return ms_misc_posts_whattoexpect2(inputs)
	if (locale === "da") return da_misc_posts_whattoexpect2(inputs)
	if (locale === "de") return de_misc_posts_whattoexpect2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_whattoexpect2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_whattoexpect2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_whattoexpect2(inputs)
	if (locale === "fil") return fil_misc_posts_whattoexpect2(inputs)
	if (locale === "fr") return fr_misc_posts_whattoexpect2(inputs)
	if (locale === "it") return it_misc_posts_whattoexpect2(inputs)
	if (locale === "hu") return hu_misc_posts_whattoexpect2(inputs)
	if (locale === "nl") return nl_misc_posts_whattoexpect2(inputs)
	if (locale === "no") return no_misc_posts_whattoexpect2(inputs)
	if (locale === "pl") return pl_misc_posts_whattoexpect2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_whattoexpect2(inputs)
	if (locale === "pt") return pt_misc_posts_whattoexpect2(inputs)
	if (locale === "ro") return ro_misc_posts_whattoexpect2(inputs)
	if (locale === "fi") return fi_misc_posts_whattoexpect2(inputs)
	if (locale === "sv") return sv_misc_posts_whattoexpect2(inputs)
	if (locale === "vi") return vi_misc_posts_whattoexpect2(inputs)
	if (locale === "tr") return tr_misc_posts_whattoexpect2(inputs)
	if (locale === "cs") return cs_misc_posts_whattoexpect2(inputs)
	if (locale === "bg") return bg_misc_posts_whattoexpect2(inputs)
	if (locale === "ru") return ru_misc_posts_whattoexpect2(inputs)
	if (locale === "uk") return uk_misc_posts_whattoexpect2(inputs)
	if (locale === "ar") return ar_misc_posts_whattoexpect2(inputs)
	if (locale === "hi") return hi_misc_posts_whattoexpect2(inputs)
	if (locale === "th") return th_misc_posts_whattoexpect2(inputs)
	if (locale === "ja") return ja_misc_posts_whattoexpect2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_whattoexpect2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_whattoexpect2(inputs)
	return ko_misc_posts_whattoexpect2(inputs)
});
export { misc_posts_whattoexpect2 as "misc.posts.whatToExpect" }